export const errorModalId = "error-dialog-modal-id";

export const simpleModalId = "simple-confirm-modal-id";

/****************************** recruit ****************************************/
// invite
export const inviteModalId = "invite-modal-id";
export const inviteEditViewSidebarId = "invite-edit-view-sidebar-id";

// ddi
export const ddiModalId = "ddi-modal-id";
export const ddiEditViewSidebarId = "ddi-edit-view-sidebar-id";

// harrison
export const harrisonModalId = "harrison-modal-id";
export const harrisonEditViewSidebarId = "harrison-edit-view-sidebar-id";
/****************************** recruit ****************************************/

/****************************** enterprise ****************************************/
// account
export const enterpriseAccountModalId = "enterprise-account-modal-id";
export const enterpriseAccountEditViewSidebarId =
  "enterprise-account-edit-view-sidebar-id";

// role
export const enterpriseRoleModalId = "enterprise-role-modal-id";
export const enterpriseRoleEditViewSidebarId =
  "enterprise-role-view-sidebar-id";

// system
export const systemModalId = "system-modal-id";
export const systemEditViewSidebarId = "system-edit-view-sidebar-id";
export const uploadFileModalId = "upload-file-modal-id";

/****************************** enterprise ****************************************/

/****************************** vacancy ****************************************/
// invite
export const vacancyInviteModalId = "vacancy-invite-modal-id";
export const vacancyInviteEditViewSidebarId =
  "vacancy-invite-edit-view-sidebar-id";

// subject
export const vacancySubjectModalId = "vacancy-subject-modal-id";
export const vacancySubjectEditViewSidebarId =
  "vacancy-subject-edit-view-sidebar-id";
/****************************** vacancy ****************************************/

/****************************** video ****************************************/
// exam
export const videoExamModalId = "video-exam-modal-id";
export const videoExamEditViewSidebarId = "video-exam-edit-view-sidebar-id";

// question
export const videoQuestionModalId = "video-question-modal-id";
export const videoQuestionEditViewSidebarId =
  "video-question-edit-view-sidebar-id";
/****************************** video ****************************************/

/****************************** report ****************************************/
// cat
export const reportCatModalId = "report-cat-modal-id";

// video
export const reportVideoCommentSidebarId = "report-video-comment-sidebar-id";
export const reportVideoModalId = "report-video-modal-id";
/****************************** report ****************************************/

/****************************** login ****************************************/
// alert
export const loginAlertModalId = "login-alert-modal-id";
/****************************** login ****************************************/
/****************************** quota ****************************************/
export const quotaEditViewSidebarId = "quota-edit-view-sidebar-id";
export const quotaBlockModalId = "quota-block-modal-id";
/****************************** quota ****************************************/
